import affaireApi from "@/api/affaireApi"

export async function confirmDeleteAffaire(affaireId, affaireNom, deleteCallback = null) {
    let {isConfirmed} = await this.$swal({
        title: 'Supprimer Affaire',
        text: `Etes-vous sûr de vouloir supprimer l'affaire ${affaireNom}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmer',
        cancelButtonText: "Annuler",
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
    })

    if(isConfirmed)
        await this.deleteAffaire(affaireId, deleteCallback);
}

export async function deleteAffaire(affaireId, deleteCallback = null) {
    if(this.hasOwnProperty("deleting"))
        this.deleting = true;
    try {
        await affaireApi.deleteAffaire(affaireId);
        this.showToast("success", "Affaire supprimée", "CheckIcon")
        if(deleteCallback != null && typeof deleteCallback === "function")
            deleteCallback(affaireId);
        
    } catch(e) {
        console.log("e", e)
        this.showToast("danger", "Une erreur s'est produite", "AlertCircleIcon")
    }
    finally {
        if(this.hasOwnProperty("deleting"))
            this.deleting = false;
    }
}